import { render, staticRenderFns } from "./LanguageDropDown.vue?vue&type=template&id=f7015468&scoped=true&"
import script from "./LanguageDropDown.vue?vue&type=script&lang=js&"
export * from "./LanguageDropDown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDropDown.vue?vue&type=style&index=0&id=f7015468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7015468",
  null
  
)

export default component.exports